<style lang="less">
@import url('./index.less');
</style>

<template>
  <div class="my_scroll">
    <div class="expers-read-container">
      <div class="expers-tab">
        <van-tabs 
          v-model="active" 
          swipeable
          background="#FF8E2E" 
          color="#FFFFFF" 
          title-inactive-color="#FFFFFF" 
          title-active-color="#FFFFFF"
          :line-width="22" 
          :style="{height:'100%'}"
        >
          <van-tab v-for="(item,index) in tabList" :key="item.key" :style="{height:'100%'}" :title="item.name">
            <div class="experts-wrap" v-if="index === 0"><ExpertsQuestion /></div>
            <div class="experts-wrap" v-if="index === 1"><DiseaseScience /></div>
            <div class="experts-wrap" v-if="index === 2"><LiveOnline /></div>
            <div><Chatbot /></div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { Tab, Tabs } from 'vant';
import ExpertsQuestion from '@/views/experts-question/ExpertsQuestion.vue'
import DiseaseScience from '@/views/disease-science/DiseaseScience.vue'
import LiveOnline from '@/views/live-online/LiveOnline.vue'
import Chatbot from '@/components/Chatbot.vue'
import { mapState } from 'vuex'
export default {
  name:'expers',
  data() {
    return {
      active:0,
      tabList:[
        {
          name:'专家问答',
          key:'0'
        },
        {
          name:'疾病科普',
          key:'1'
        },
        {
          name:'在线直播',
          key:'2'
        }
      ]
    }
  },
  components:{
    ExpertsQuestion,
    DiseaseScience,
    LiveOnline,
    Chatbot,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  provide () {
    return {
      parent: this
    }
  },
  computed:{
    ...mapState({
      tabSelect:state => state.tabSelect
    }),
    parentTabSelect(){
      const setLists = (data)=>{
        data.map(obj=>{
            obj.text = obj.name
          obj.value = obj.name
        })
        return data
      }
      let data =  {
        quiFields:[
          { text: "全部疾病", value:''},
          ...setLists(this.getLists('field')).reverse()
        ],
        quiTags:[
           { text: "全部标签", value:''},
            ...setLists(this.getLists('tag')) 
        ],
        popularScienceFields:[
           { text: "全部疾病", value:''},
            ...setLists(this.getLists('field','popular_science')).reverse()
        ],
        popularScienceTags:[
            { text: "全部标签", value:''},
            ...setLists(this.getLists('tag','popular_science')) 
        ],
        liveVideoFields:[
            { text: "全部疾病", value:''},
             ...setLists(this.getLists('field','live_video')).reverse()
        ]
      }
      return data
    }
  },
  created() {
    document.title = '疫情e课'
    var keepActive = sessionStorage.getItem('keep_active')
    if(keepActive) {
      this.active = Number(keepActive)
    }
  },
  methods:{
    getLists(key,target = 'quiz'){
      try {
        return this.tabSelect.tabSelect[target][key] || []
      } catch(e){
        return []
      }
    }
  }
}
</script>